/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid, FormGroup, FormControlLabel } from '@mui/material';
import React, { useEffect, useState } from 'react'
import MUICheckbox from '../MUICheckbox/MUICheckbox';

interface IUsersData {
  id?: any | null;
  firstName: string;
  lastName?: string | null | undefined;
  email: string;
  password: string;
  clientId: number;
  passwordResetKey?: any | null;
  resetKeySentOn?: any | null;
  isDeleted: boolean;
  isActive: boolean;
  timeZone?: any | null;
  phone?: any | null;
  roleId?: any | null;
  createdBy: string;
  createdOn: string;
  createdSource: string;
  modifiedBy?: any | null;
  modifiedOn?: any | null;
  modifiedSource?: any | null;
  //For user role
  hasRole: boolean;
  name: string;
  userID:any;
  hasWebAccess: boolean;
  hasAPIAccess : boolean;
  roleName: string | null;
}

interface SelectedUserId {
    id: number;
  }

interface UsersTabContentProps {
    userData: IUsersData;
    index: number;
    onItemSelect: ({ userObj, checked }: { userObj: SelectedUserId; checked: boolean }) => void;
    selected: boolean; // Add selected prop to the interface
    selectAllChecked: boolean; // Add selectAllChecked prop to the interface
  }
  
  function AddUsersTabContent({ userData, onItemSelect, selected, selectAllChecked   }: UsersTabContentProps):JSX.Element {
    // const [isChecked, setIsChecked] = useState<boolean>(selected); // Use selected prop to initialize isChecked state
    const [isChecked, setIsChecked] = useState<boolean>(selectAllChecked || selected); // Update isChecked state


    useEffect(() => {
      setIsChecked(selectAllChecked || selected);
  }, [selectAllChecked, selected]);


    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const checked = event.target.checked;
        const userId: number = userData.userID;
        setIsChecked(checked);
        const userObj = {
            id: userId
        };
        onItemSelect({ userObj, checked });
    };
  
    return (
      <div>
        <Grid container spacing={0} alignItems="center" sx={{paddingLeft: '10px'}}>
          <Grid item xs={6} style={{ display: 'flex', alignItems: 'center' }}>
            <FormGroup>
              <FormControlLabel control={<MUICheckbox checked={isChecked} onChange={handleCheckboxChange} />} label="" />
            </FormGroup>
              <div className="btn btn-ghost btn-circle user-profile-icon" style={{ marginRight: '10px' }}>
                {`${(userData !== undefined && userData.name !== undefined) ? userData.name.charAt(0).toUpperCase() : ''}${userData.lastName?.charAt(0) ?? ""}`}
              </div>
              <p className='text-muted text-14 font-normal mb-0 ml-0'>{userData.name}</p>
          </Grid>
        </Grid>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <hr style={{ border: 'none', borderBottom: '1px solid #e0e0e0', width: 'calc(100% - 15px)', margin: '4px 6px' }} />
        </div>
      </div>
    );
  }  
export default AddUsersTabContent;
